<script setup lang="ts">
import { RemoteSelect } from '@/shared/ui/RemoteSelect'

import { useEntitySearch } from '../model/useEntitySearch'

const { selected, options, isFetching, onSearch, onSelect } = useEntitySearch()
</script>

<template>
  <RemoteSelect
    v-model="selected"
    :options="options"
    :remote-method="onSearch"
    :loading="isFetching"
    placeholder="Search..."
    @change="onSelect"
  />
</template>
